import { useSentryToolbar } from '@sentry/toolbar';
import * as React from 'react';
interface SentryToolbarProps {
  enabled?: boolean;
  organizationSlug: string;
  projectIdOrSlug: string | number;
  environment?: string | string[];
  placement?: 'right-edge' | 'bottom-right-corner';
  theme?: 'system' | 'dark' | 'light';
  sentryOrigin?: string;
  domId?: string;
  debug?: string;
}

/**
 * Komponent Sentry Toolbar
 *
 * Wyświetla toolbar z informacjami z Sentry bezpośrednio w aplikacji.
 * Toolbar jest dostępny tylko w środowiskach development i staging.
 *
 * @param props - Konfiguracja Sentry Toolbar
 * @returns Komponent Sentry Toolbar
 */
const SentryToolbar = ({
  enabled,
  organizationSlug,
  projectIdOrSlug,
  environment,
  placement = 'right-edge',
  theme = 'system',
  sentryOrigin,
  domId = 'sentry-toolbar',
  debug
}) => {
  // Użyj hooka z paczki @sentry/toolbar
  useSentryToolbar({
    enabled,
    initProps: {
      organizationSlug,
      projectIdOrSlug,
      environment,
      placement: placement as 'right-edge' | 'bottom-right-corner',
      theme: theme as 'system' | 'dark' | 'light',
      sentryOrigin,
      domId,
      debug
    }
  });

  // Komponent nie renderuje niczego wizualnie
  // Toolbar jest montowany bezpośrednio do DOM przez Sentry
  return null;
};
const SentryToolbarComponent = SentryToolbar as React.FC<SentryToolbarProps>;
export default SentryToolbarComponent;